import React from "react";
import '../Reportes.css';
import { List, Col, Row, Skeleton} from "antd";
import { Redirect } from 'react-router';
import { fileToObject } from "antd/lib/upload/utils";




const headers = [     {tag: "Tipo de clasificación",    width:3, style:"texto-centrado"},
                      {tag: "Tipo artículo",       width:2, style:"texto-centrado"},
                      {tag: "Tipo de elección",    width:3, style:"texto-centrado"},
                      {tag: "Documento",           width:3, style:"texto-centrado"},
                      {tag: "Cantidad a producir", width:2, style:"texto-centrado"},
                      {tag: "Cantidad producida",  width:3, style:"texto-centrado"},
                      {tag: "Fecha de elaboración",width:4, style:"texto-centrado"},
                      {tag: "Observaciones",       width:4, style:"texto-centrado"}];
                         
const headersOc = [   {tag: "Entidad",              width:2, style:"texto-centrado"},
                      {tag: "Tipo de clasificación",width:3, style:"texto-centrado"},
                      {tag: "Tipo artículo",       width:2, style:"texto-centrado"},
                      {tag: "Tipo de elección",    width:3, style:"texto-centrado"},
                      {tag: "Documento",           width:3, style:"texto-centrado"},
                      {tag: "Cantidad a producir", width:2, style:"texto-centrado"},
                      {tag: "Cantidad producida",  width:3, style:"texto-centrado"},
                      {tag: "Fecha de elaboración",width:4, style:"texto-centrado"},
                      {tag: "Observaciones",       width:2, style:"texto-centrado"}];

const headersAvanceGlobal 
                = [   {tag: "Entidad",              width:5, style:"texto-centrado"},
                      {tag: "Tipo artículo",       width:5, style:"texto-centrado"},
                      {tag: "Cantidad a producir", width:6, style:"texto-centrado"},
                      {tag: "Cantidad producida",  width:8, style:"texto-centrado"}];

const subHeaders = [  {tag: "",       field: "nombreDocumentacion", width:3, style:"texto-centrado"},
                      {tag: "",       field: "subclasificacion",   width:2, style:"texto-centrado"},
                      {tag: "",       field: "nombreEleccion",             width:3, style:"texto-izquierda"},
                      {tag: "",       field: "nombre",             width:3, style:"texto-izquierda"},
                      {tag: "Piezas", field: "piezasAsignadas",    width:2, style:"texto-centrado"},
                      {tag: "Piezas", field: "cantidadAcumulada",  width:1, style:"texto-centrado"},
                      {tag: "%",      field: "porcentajeAcumulado",width:2, style:"texto-centrado", formatNumber: true},
                      {tag: "Inicio", field: "fechaInicio",        width:2, style:"texto-centrado"},
                      {tag: "Término",field: "fechaFin",           width:2, style:"texto-centrado"},
                      {tag: "",       field: "observaciones",      width:4, style:"texto-centrado"}];
                        
const subHeadersOc = [{tag: "",       field: "nombreEstado",       width:2, style:"texto-centrado"},
                      {tag: "",       field: "nombreDocumentacion", width:3, style:"texto-centrado"},
                      {tag: "",       field: "subclasificacion",   width:2, style:"texto-centrado"},
                      {tag: "",       field: "nombreEleccion",     width:3, style:"texto-izquierda"},
                      {tag: "",       field: "nombre",             width:3, style:"texto-izquierda"},
                      {tag: "Piezas", field: "piezasAsignadas",    width:2, style:"texto-centrado"},
                      {tag: "Piezas", field: "cantidadAcumulada",  width:1, style:"texto-centrado"},
                      {tag: "%",      field: "porcentajeAcumulado",width:2, style:"texto-centrado", formatNumber: true},
                      {tag: "Inicio", field: "fechaInicio",        width:2, style:"texto-centrado"},
                      {tag: "Término",field: "fechaFin",           width:2, style:"texto-centrado"},
                      {tag: "",       field: "observaciones",      width:2, style:"texto-centrado"}];

const subHeadersAvanceGlobal = 
                     [{tag: "",       field: "nombreEstado",       width:5, style:"texto-centrado"},
                      {tag: "",       field: "subclasificacion",   width:5, style:"texto-centrado"},
                      {tag: "Piezas", field: "piezasAsignadas",    width:6, style:"texto-centrado"},
                      {tag: "Piezas", field: "cantidadAcumulada",  width:4, style:"texto-centrado"},
                      {tag: "%",      field: "porcentajeAcumulado",width:4, style:"texto-centrado", formatNumber: true}]; 

class ReporteProduccionDocumentos extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
       
            redirect: false,
   
        };

    }

    componentDidMount() {


    }

    buildHeaders = (structure) =>{

        let headers=[];
    
        for(var i=0;i<structure.length;i++){
            headers.push(
                <Col xs={structure[i].width} className={structure[i].style} key={i}>
                {structure[i].tag}                
            </Col>
            )
        }
        return headers;
    };


    generateTableData(data,structure){
        let tableData=[];
        const mapa = new Map(Object.entries(data));
        for(var i =0; i < structure.length; i++){
            let formatNumber = structure[i].formatNumber;
            tableData.push(
                <Col span={structure[i].width} className={structure[i].style+' fila'} key={i} style={{'word-break': 'break-word'}}>
                    {formatNumber ? Number(mapa.get(structure[i].field).toLocaleString("en-US")).toFixed(2) : mapa.get(structure[i].field)}
               </Col>
            )
        }
        return tableData;
    }





    render() {

        if (this.state.redirect) {
            return <Redirect push to="/reportes" />;
        }

        
        return (

            <div>
                <br />
                <List
                    header={
                      <Row>
                        <Col>
                          <Row className="header-tabla-gris">
                            {this.buildHeaders(this.props.isOc==true?headersOc:headers)}
                          </Row>
                          <Row className="subheader-tabla">
                            {this.buildHeaders(this.props.isOc==true?subHeadersOc:subHeaders)}
                          </Row>
                        </Col>
                      </Row>
                    }
                    pagination={{
                        pageSize: 6,
                    }}
                    size="large"
                    loading={this.props.isLoading}
                    itemLayout="horizontal"
                    dataSource={this.props.documentos}
                    renderItem={item =>
                        <List.Item>
                            <Skeleton title={false} loading={this.props.isLoading} >
                                <List.Item.Meta
                                    description={
                                        <Row>
                                             {this.generateTableData(item,this.props.isOc==true?subHeadersOc:subHeaders)}
                                        </Row>
                                    }
                                />
                            </Skeleton>
                        </List.Item>
                    }

                />
                {this.props.documentosAvanceGlobal && this.props.documentosAvanceGlobal.length > 0 && this.props.isOc && <>
                  <br />
                  <List
                      header={
                        <Row>
                          <Col>
                            <Row>
                              <Col span={24} className="texto-centrado" style={{fontSize: '18px', fontWeight: 'bold'}}>Avance general</Col>
                            </Row>
                            <Row className="header-tabla-gris">
                              {this.buildHeaders(headersAvanceGlobal)}
                            </Row>
                            <Row className="subheader-tabla">
                              {this.buildHeaders(subHeadersAvanceGlobal)}
                            </Row>
                          </Col>
                        </Row>
                      }
                      pagination={{
                          pageSize: 20,
                      }}
                      size="large"
                      loading={this.props.isLoading}
                      itemLayout="horizontal"
                      dataSource={this.props.documentosAvanceGlobal}
                      renderItem={item =>
                          <List.Item>
                              <Skeleton title={false} loading={this.props.isLoading} >
                                  <List.Item.Meta
                                      description={
                                          <Row>
                                              {this.generateTableData(item,subHeadersAvanceGlobal)}
                                          </Row>
                                      }
                                  />
                              </Skeleton>
                          </List.Item>
                      }

                  />
                </>}
              </div>
        );
    
}
}

export default ReporteProduccionDocumentos;